import axios from '../utils/Http.js'
import notify from '../utils/notify/Notify.js'
import { dateJs2django, sortBookings } from '../utils/Filters.js'

const state = {
    resource: null,
    start_datetime: null,
    duration: null,
    end_datetime: null,
    title: null,
    purpose: null,
    resource_list: null,
    user_booking_list: null,
    booking_list: null
}

const getters = {
    getResource (state) {
        return state.resource ? state.resource : false
    },
    getStartDateTime (state) {
        return state.start_datetime ? state.start_datetime : false 
    },
    getEndDateTime (state) {
        return state.end_datetime ? state.end_datetime : false
    },
    getDuration (state) {
        return state.duration ? state.duration : false
    },
    getTitle (state) {
        return state.title ? state.title : ''
    },
    getPurpose (state) {
        return state.purpose ? state.purpose : ''
    },
    getResourceList (state) {
        return state.resource_list ? state.resource_list : false
    },
    getUserBookingList (state) {
        return state.user_booking_list ? state.user_booking_list : false
    },
    getBookingList (state) {
        return state.booking_list ? state.booking_list : false
    }
}

const mutations = {
    setResource (state, resource) {
        state.resource = resource
    },
    setStartDateTime (state, datetime) { // datetime should be a JS date object
        state.start_datetime = datetime
    },
    setDuration (state, duration) { // duration should be an integer of minutes. Ex '180' (3 hours)
        state.duration = duration
        this.commit('setEndDateTime')
    },
    setTitle (state, title) { // title should be a text string
        state.title = title
    },
    setPurpose (state, purpose) { // purpose should be a text string
        state.purpose = purpose
    },
    setEndDateTime (state) {
        if (state.start_datetime && state.duration) {
            let d = new Date(state.start_datetime)
            d.setMinutes(d.getMinutes() + state.duration.value)
            state.end_datetime = d
        }
    },
    setResourceList(state, resources) {
        state.resource_list = resources
    },
    setUserBookingList(state, bookings) {
        state.user_booking_list = bookings
    },
    setBookingList(state, bookings) {
        state.booking_list = bookings
    },
    clearState (state) {
        state.resource = null
        state.start_datetime = null
        state.duration = null
        state.title = null
        state.purpose = null
        state.end_datetime = null,
        state.user_booking_list = null,
        state.booking_list = null
    }
}

const actions = {
    fetchResources: function({commit, rootState}, url) {
        const options = {
            method: 'get',
            url: url
        }
        if (rootState.auth.sessionKey) {
            options.headers = {
                'Authorization': 'Token ' + rootState.auth.sessionKey
            }
        }
        axios(options)
        .then(res => {
            commit('setResourceList', res.data)
        })
        .catch(err => console.log(err))
    },
    fetchResource: function({commit, rootState, dispatch}, url) {
        const options = {
            method: 'get',
            url: url
        }
        if (rootState.auth.sessionKey) {
            options.headers = {
                'Authorization': 'Token ' + rootState.auth.sessionKey
            }
        }
        axios(options)
        .then(res => {
            commit('setResource', res.data)
        })
        .catch(err => console.log(err))
    },
    fetchUserBookings: function({commit, rootState}, options) {
        if (!options) {
            let now = new Date(),
                years_from_now = new Date(new Date().setFullYear(now.getFullYear() + 10))
                options = `from=${ encodeURIComponent(dateJs2django(now)) }&to=${ encodeURIComponent( dateJs2django(years_from_now)) }`
        }
        setTimeout(function() { // Adding a slight delay because the backend can be slow about reading to DB
            axios({
                method: 'get',
                url: `/booking/booking/?creator=${ rootState.auth.user.id }&${ options }`,
                headers: {
                    'Authorization': 'Token ' + rootState.auth.sessionKey
                }
            })
            .then(res => {
                let bookings = sortBookings(res.data)
                commit('setUserBookingList', bookings)
            })
            .catch(err => console.log(err))
        }, 200) 

    },
    fetchBookings: function({commit, rootState}, options) {
        setTimeout(function() { // Adding a slight delay because the backend can be slow about reading to DB
            axios({
                method: 'get',
                url: `/booking/booking/?${ options }`,
                headers: {
                    'Authorization': 'Token ' + rootState.auth.sessionKey
                }
            })
            .then(res => {
                let bookings = sortBookings(res.data)
                commit('setBookingList', bookings)
            })
            .catch(err => console.log(err))
        }, 200) 
    },
    deleteBooking: function({rootState}, booking_id) {
        axios({
            method: 'delete',
            url: `/booking/booking/${ booking_id }/`,
            headers: {
                'Authorization': 'Token ' + rootState.auth.sessionKey
            }
        })  
        .then(res => {
            notify('Du har annulleret din reservation', 'success')
        })
        .catch(err => {
            notify('Reservationen kunne ikke slettes', 'error', err.response.data)
        })
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}